import * as Yup from 'yup';

const hasPersianLetter = (value: string) => /[\u0600-\u06FF]/.test(value);
const hasEnglishLetter = (value: string) => /[A-Za-z]/.test(value);

export const GatewaySchema = Yup.object().shape({
    title: Yup.string()
        .required('وارد کردن عنوان الزامی است')
        .min(3, 'عنوان باید حداقل 3 کاراکتر باشد')
        .max(64, 'عنوان باید حداکثر 64 کاراکتر باشد')
        .test(
            'persian-gateway-title',
            'عنوان درگاه باید به زبان فارسی وارد شود و نباید شامل حروف انگلیسی باشد',
            (value) => !value || (hasPersianLetter(value) && !hasEnglishLetter(value)),
        ),

    website: Yup.string()
        .required('وارد کردن آدرس وبسایت الزامی است')
        .min(3, 'آدرس وبسایت باید حداقل 3 کاراکتر باشد')
        .max(64, 'آدرس وبسایت باید حداکثر 64 کاراکتر باشد')
        .matches(
            /^(?:https?:\/\/)?(?:www\.)?(?!ww\d*\.)[\w-]+(?:\.[\w-]+)*\.[a-zA-Z]{2,}(?:[/?#][^\s]*)?$/i,
            'لطفا آدرس معتبر وب‌سایت را وارد کنید، مانند aqayepardakht.ir یا https://aqayepardakht.ir',
        ),
});
